<div style=" margin-top: 6.5%;display: flex;width: 100%;">
    <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen">
  <app-jsip-product-info-bar (productNavToggle)="selectedProductDetails = $event"></app-jsip-product-info-bar>
<div  [style.background-color]="backgroundColorScreen"  class="top-outer-div-productdetails" [class.productDetailsCollapsed]="selectedProductDetails == null" >

    <div class="agGridOuterDiv">
        <div>

            <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;margin-top: 0;">
                <label i18n="@@spmsUserReg" class="textColour">Deviation Management</label>
                <span class="example-spacer"></span>
                <div style="display: flex; margin-top: 15px; margin-left: 0px;">
                  
                  </div>
            <div *ngIf="showClearFilterCheckbox" class="filter-toggle">
                <mat-checkbox
                    color="primary"
                    (change)="onClearDeviationFilter($event.checked)">
                    Show All Deviations
                </mat-checkbox>
                </div>

                <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Add" (click) = "onAdd()">
                    Add Record<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>
                </button>   -->

        <app-common-button
          label="Add Record" 
          title="Add Record "
          icon="fas fa-plus-circle"
          [buttonId]="114"
          width="130px"
          [critical]="true"
          (clicked)="onAdd()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
                <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "onRefresh()">
                    Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-sync-alt" title="Refresh"></em>
                </button> -->
            <app-common-button
          label="Refresh"
          title="Refresh "
		  icon="fas fa-sync-alt"
          [buttonId]="1111"
			width="110px"
          [critical]="false"
          (clicked)="onRefresh()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
                <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">
                    Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                </button> -->
        <app-common-button
          label="Download"
          title="Download "
		  icon="fas fa-download example-icon"
          [buttonId]="1111"
			width="110px"
          [critical]="false"
          (clicked)="onBtExport()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
                
                <div class="insertPageNoDiv" style="width:6.5%">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@Targetpageno">Page No</mat-label>
                        <input matInput type="text" (input)="onSearchChange($event.target.value)">
                    </mat-form-field>
                </div>
                <div class="selectRecordsDiv" style="width:8%">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                        <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged(value)">
                            <mat-option value="10" selected>10</mat-option>
                            <mat-option value="200">200</mat-option>
                            <mat-option value="300">300</mat-option>
                            <mat-option value="400">400</mat-option>
                        </mat-select>

                    </mat-form-field>
                </div>
                <div class="card pagination paginationFirstButton paginationFirstlastButton">
                    <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                </div>
                <div class="card pagination paginationButtons btn-rounded">
                    <ul>
                        <li class="paginationliicon">
                            <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
                        </li>
                        <li>{{currentPage}}/{{totalPages}}</li>
                        <li class="paginationliicon" style="padding:0; margin-right: 5px;">
                            <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
                        </li>
                    </ul>
                </div>
                <div class="card pagination paginationLastButton paginationFirstlastButton">
                    <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                </div>

            </mat-toolbar>
        </div>
        <div>

<ag-grid-angular
  class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass thin"
  style="width: 100%; height: calc(92vh - 150px);"

  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  
  [gridOptions]="gridOptions"

  (rowClicked)="onRowClicked($event)"

  [rowSelection]="rowSelection"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  [paginationNumberFormatter]="paginationNumberFormatter"
  
  [headerHeight]="35"
  [enableBrowserTooltips]="true"

  [animateRows]="true"
  [suppressPaginationPanel]="true"

  [rowClassRules]="rowClassRules"
  [components]="components"

  (paginationChanged)="onPaginationChanged()"
  (gridReady)="onGridReady($event)"
  [getRowId]="gridOptions?.getRowId">
</ag-grid-angular>



        </div>

    </div>
</div>
</div>
</div>

